<template>
  <div class="flex-row jcsb adv-widget-wrapper" v-show="!isStickyBottom">
    <div
      class="flex-column gap8 mr8 align-items-start justify-content-around pdt6r"
    >
      <img src="../../../default/images/global/divider.svg" class="" />
      <div class="flex-column align-items-start gap4 mt4 adv-info">
        <span class="adv-title">{{ advTitle }}</span>
        <span class="adv-time-text" v-html="advTimeText"></span>
      </div>
    </div>
    <div class="clock_adv_icon">
      <img
        :src="orderStatusIcon"
        class="clock_adv_img"
        v-if="orderStatusIcon"
      />
    </div>
  </div>
  <div
    v-show="isStickyBottom"
    @click="openTrackingPage"
    class="adv-sticky"
  >
    <div class="flex-row jcsb align-items-start">
      <div
        class="flex-column gap8 mr8 align-items-start justify-content-around"
      >
        <span class="adv-title">{{ advTitle }}</span>
        <span class="adv-time-text" v-html="advTimeText"></span>
      </div>
      <img src="../../../default/images/global/nxg-expand.svg" class="" />
    </div>
  </div>
</template>

<script>
import {
  ORDER_TYPE,
  ORDER_STATUS_DEL,
  DELIVERY_TYPE
} from '../helpers/paymentConstants'
export default {
  name: 'NxgAdvWidget',
  props: [
    'orderSummary',
    'currentIndex',
    'isStickyBottom',
    'moduleProps',
    'totalOrderCount',
    'isNgAdvanceOrder'
  ],

  computed: {
    orderStatusIcon () {
      if (this.isAdvOrderValid)
        return (
          this.moduleProps?.advance_order_icon ||
          require('../../../default/images/global/clock_adv.svg')
        )
    },
    isAdvOrderValid () {
      const statusCode = this.orderSummary?.orderCurrentState || 0
      return (
        this.isNgAdvanceOrder &&
        this.orderSummary?.advanceOrder &&
        statusCode == 1
      )
    },
    advTimeText () {
      const timestamp = this.orderSummary?.advanceOrderDeliveryTime
      const addres =
        this.orderSummary?.deliveryAddress?.customer_address_name || 'Other' //this is need to be replaced with formatted_address
      if (!timestamp) return ''

      const date = new Date(timestamp * 1000)
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      const day = date.getDate()
      const month = months[date.getMonth()]
      let hours = date.getHours()
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const meridiem = hours >= 12 ? 'PM' : 'AM'
      hours = hours % 12 || 12
      const address = addres
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')

      return `${day} ${month}, ${hours}:${minutes} ${meridiem} <span class="adv-zone">at</span> ${address}`
    },
    advTitle () {
      const title = this.orderSummary?.deliveryOrderType?.deliveryTypeCode ===
        ORDER_TYPE.PICKUP
        ? this.moduleProps.ad_pickup_label
        : this.orderSummary?.deliveryOrderType?.deliveryTypeCode ==
          ORDER_TYPE.DINEIN
        ? this.moduleProps?.ad_dinein_label
        : this.orderSummary?.deliveryOrderType?.deliveryTypeCode ==
          ORDER_TYPE.DELIVERY
        ? this.moduleProps?.ad_deliver_label
        : null

        return title?.toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  }
}
</script>
